<template>
  <div class="mt-12">
    <v-row>
      <v-col cols="12" sm="8" md="8">
        <h1 class="font-weight-bold" style="font-size: 20px; line-height: 23px">
          Resultados da consulta
        </h1>
        <h3
          style="font-style: normal; font-weight: 300; font-size: 16px; line-height: 20px"
        >
          Você pode alterar o período da consulta com os filtros avançados
        </h3>
      </v-col>
      <v-spacer />
      <v-col
        cols="12"
        sm="4"
        md="4"
        align-self="start"
        align="start"
        v-if="this.$vuetify.breakpoint.name === 'xs'"
      >
        <div class="mr-2" @click="filter = !filter" style="cursor: pointer">
          <v-icon color="secondary lighten-1">mdi-filter-outline</v-icon>
          <span class="secondary--text text--lighten-1"
            >Filtrar para outros períodos</span
          >
        </div>
      </v-col>
      <v-col cols="12" sm="4" md="4" align-self="end" align="end" v-else>
        <div class="mr-2" @click="filter = !filter" style="cursor: pointer">
          <v-icon color="secondary lighten-1" left> mdi-filter-outline </v-icon>
          <span class="secondary--text text--lighten-1"
            >Filtrar para outros períodos</span
          >
        </div>
      </v-col>
    </v-row>
    <search-other-period-date
      v-if="getType && filter && !loadingData"
      :type="getType"
      @applyPeriod="applyPeriod($event)"
    ></search-other-period-date>

    <v-card v-if="showAnimation" class="mt-3 primary primary darken-1">
      <div style="height: 300px">
        <loading-animation @loopComplete="loadAnimationComplete"></loading-animation>
      </div>
    </v-card>
    <div v-else>
      <v-card color="mt-3 pa-2 primary darken-1" min-height="600">
        <h3
          class="ml-4 mt-4"
          v-if="dataPeriodDate"
          style="color: #a0a0a0; font-weight: normal; font-size: 12px; line-height: 16px"
        >
          <v-icon color="#A0A0A0">mdi-calendar-month-outline</v-icon>
          Visualizando dados de {{ formatDate(dataPeriodDate[0]) }} a
          {{ formatDate(dataPeriodDate[1]) }}
        </h3>
        <v-card-title class="mb-0">
          <chart-header
            :authorize="authorize"
            :isTable="isTableTab"
            @fullscreenChart="fullscreenChart"
            @printChart="printChart"
            @exportChart="exportChart($event)"
            @exportPDF="exportPDF"
            @exportCSV="exportCSV"
            @exportXLS="exportXLS"
          >
            <template v-slot:title v-if="searchResult">
              {{ searchResult.location.text }}
            </template>
          </chart-header>
        </v-card-title>
        <v-card-text>
          <h3 class="subtitle-1 white--text">Selecione o tipo de visualização:</h3>
          <v-tabs
            class="hidden-sm-an-down secondary--text text--lighten-1"
            v-model="tab"
            active-class="secondary lighten-1 primary--text text--darken-1"
            background-color="primary darken-1"
            slider-color="secondary lighten-1"
          >
            <v-tab
              class="tab-item-title"
              v-for="(item, index) in items"
              :key="index"
              :id="item.id"
            >
              {{ item.title }}
            </v-tab>
          </v-tabs>
          <v-menu bottom left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="hidden-md-and-up tab-item-title transparent"
                outlined
                v-bind="attrs"
                v-on="on"
              >
                {{ items[tab].title }}
                <v-icon> mdi-menu-down </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in items"
                :key="index"
                @click="changeTabItem(index)"
              >
                {{ item.title }}
              </v-list-item>
            </v-list>
          </v-menu>
          <v-tabs-items v-model="tab" class="primary darken-1" touchless>
            <v-tab-item class="px-0">
              <v-card flat color="primary darken-1">
                <v-card-text v-if="alert">
                  <br />
                  <v-icon class="mr-2" color="warning">mdi-alert-circle-outline</v-icon>
                  <span class="warning--text"
                    >Não há resultados no período pesquisado.</span
                  >
                </v-card-text>
                <v-card-text v-else>
                  <rain-estimation-historical-data-chart
                    ref="rainEstimationHistoricalDataChart"
                    :series="series"
                    :description="description"
                    :caption="caption"
                    :searchResult="searchResult"
                    @chartRenderComplete="chartRenderComplete($event)"
                  ></rain-estimation-historical-data-chart>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card class="px-6" flat color="primary darken-1">
                <v-card-text v-if="alert">
                  <br />
                  <v-icon class="mr-2" color="warning">mdi-alert-circle-outline</v-icon>
                  <span class="warning--text"
                    >Não há resultados no período pesquisado.</span
                  >
                </v-card-text>
                <v-card-text v-else>
                  <rain-estimation-historical-data-table-daily-monthly
                    v-if="getType === 'mensal' || getType === 'diario'"
                    :ref="dailyMonthlyTableDataRef"
                    :searchResult="searchResult"
                  ></rain-estimation-historical-data-table-daily-monthly>
                </v-card-text>
                <!--                <rain-estimation-historical-data-table-hourly
                  v-if="getType === 'horario'"
                  :searchResult="searchResult"
                  :ref="hourlyTableDataRef"
                ></rain-estimation-historical-data-table-hourly>-->
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </div>
    <settings-export-dialog
      ref="settingsExportDialog"
      @exportData="exportDataTable($event)"
    ></settings-export-dialog>
  </div>
</template>

<script>
import moment from "moment";
import LoadingAnimation from "../LoadingAnimation.vue";
import SearchOtherPeriodDate from "./SearchOtherPeriodDate";
import ChartHeader from "../ChartHeader.vue";
import RainEstimationHistoricalDataChart from "./RainEstimationHistoricalDataChart.vue";
import Highcharts from "highcharts";
import Exporting from "highcharts/modules/exporting";
import { rainEstimationHistoricalDataAuthorization } from "../../../helpers/chart_export_authorization";
import { tableBasinsData } from "../../../helpers/chart_export_authorization";
import RainEstimationHistoricalDataTableDailyMonthly from "./RainEstimationHistoricalDataTableDailyMonthly";
import SettingsExportDialog from "../../stations-data/SettingsExportDialog";
Exporting(Highcharts);
export default {
  name: "RainEstimationHistoricalSearchResult",
  props: {
    searchResult: {
      type: Object,
    },
    type: {
      type: String,
    },
    loadingOtherPeriod: {
      type: Boolean,
      default: false,
    },
    loadingData: {
      type: Boolean,
      default: false,
    },
    types: {
      type: Array,
    },
  },
  components: {
    SettingsExportDialog,
    RainEstimationHistoricalDataTableDailyMonthly,
    LoadingAnimation,
    SearchOtherPeriodDate,
    ChartHeader,
    RainEstimationHistoricalDataChart,
  },
  data: () => ({
    tab: undefined,
    items: [
      {
        title: "Gráfico",
        id: "tab-charts",
      },
      {
        title: "Tabela",
        id: "tab-table",
      },
    ],
    authorize: [],
    filter: undefined,
    showAnimation: false,
    otherPeriodSelected: undefined,
    chartRendered: undefined,
    animationShow: false,
    loading: false,
    alert: false,
    series: [],
    caption: undefined,
    description: undefined,

    enableExportChart: false,
    exportChartAuthorized: undefined,
    dailyMonthlyTableDataRef: "dailyMonthlyTableData",
    hourlyTableDataRef: "hourlyTableData",
  }),

  created() {
    this.authorize = rainEstimationHistoricalDataAuthorization;
    this.tab = 0;
    if (this.searchResult) {
      if (this.searchResult.resultList.length > 0) {
        this.initialize();
        this.alert = false;
      } else {
        this.alert = true;
      }
    }
  },

  watch: {
    tab(value) {
      if (value === 0) {
        this.authorize = rainEstimationHistoricalDataAuthorization;
        this.enableExportChart = true;
        this.loadCharts();
      } else if (value === 1) {
        this.enableExportChart = false;
        this.authorize = tableBasinsData;
      }
      this.$gtag.event("tabs_" + this.from + "-RainEstimationHistoricalSearchResult", {
        event_category: "RainEstimationHistoricalSearchResult",
        event_label: "tab_index",
        value: value,
      });
    },
    searchResult() {
      if (this.searchResult) {
        if (this.searchResult.resultList.length > 0) {
          this.alert = false;
        } else {
          this.alert = true;
        }
      }
      if (this.searchResult.type === "horario") {
        this.initialize();
      } else if (this.searchResult.type === "diario") {
        this.initialize();
      } else if (this.searchResult.type === "mensal") {
        this.initialize();
      }
    },
    loadingOtherPeriod(value) {
      if (value) {
        this.showAnimation = this.loadingOtherPeriod;
      }
    },
    loadingData(value) {
      if (value) {
        this.showAnimation = this.loadingData;
        this.otherPeriodSelected = undefined;
      }
    },
    watchSeriesAndSearchResultValues() {
      if (this.series && this.searchResult) {
        this.loadCharts();
      }
    },
  },
  computed: {
    getType() {
      return this.type ? this.type : this.searchResult.type;
    },
    dataPeriodDate() {
      if (!this.searchResult) return undefined;
      const { date_start, date_end } = this.searchResult;
      return date_start && date_end ? [date_start, date_end] : undefined;
    },
    isTableTab() {
      return this.tab === 1;
    },
  },
  methods: {
    async initialize() {
      this.series = [];
      let data = [];
      let serie = {};
      let x, y;
      let res = this.searchResult.resultList;
      let values;
      if (this.searchResult.type === "diario") {
        values = this.searchResult.resultList;
        for (let i in values) {
          x = this.dateToUTC(values[i].date);
          y = values[i].value.precIntensity;
          data.push([x, y]);
        }
        serie = {
          name: "Precipitação",
          data: data,
          type: "column",
          yAxis: 0,
          tooltip: {
            valueSuffix: " mm",
            valueDecimals: 1
          },
          title: {
            enabled: true,
            text: "Precipitação (mm) | Total ",
            style: {
              color: "#FFFFFF"
            }
          },
          color: "#95A1EC"
        }
        this.series.push(serie);
        //flow
        data = [];
        const { flowForecasts } = this.searchResult;
        for (let item in flowForecasts) {
          x = this.dateToUTC(flowForecasts[item].date);
          y = flowForecasts[item].value.flow;
          data.push([x, y]);
        }
        serie = {
          name: "Vazão",
          data: data,
          type: "line",
          yAxis: 1,
          tooltip: {
            valueSuffix: " m³/s",
            valueDecimals: 3
          },
          title: {
            enabled: true,
            text: "Vazão (m³/s)",
            style: {
              color: "#FFFFFF"
            }
          },
          color: "#95A1EC"
        }
        //flow
        this.series.push(serie);
        this.description = `De ${moment(this.searchResult.dataType.date_start).format("DD/MM/YY")} até ${moment(this.searchResult.dataType.date_end).format("DD/MM/YY")}`,
        this.caption = {
            text: `Gráfico com dados diários de ${moment(this.searchResult.dataType.date_start).format("DD/MM/YY")} até  ${moment(this.searchResult.dataType.date_end).format("DD/MM/YY")}`,
            style: { color: "#FFFFFF" },
        };
      } else if (this.searchResult.type === "mensal") {
        data = [];
        let updatedSorted = this.mappingDates(res);
        for (let index in updatedSorted) {
          x = this.dateToUTC(updatedSorted[index].date);
          y = updatedSorted[index].value.prec;
          data.push([x, y]);
        }
        serie = {
          name: "Precipitação",
          data: data,
          type: "column",
          yAxis: 0,
          tooltip: {
            valueSuffix: " mm",
            valueDecimals: 1
          },
          title: {
            enabled: true,
            text: "Precipitação (mm) | Total ",
            style: {
              color: "#FFFFFF"
            }
          },
          color: "#95A1EC"
        }
        this.series.push(serie);
        //flow
        data = [];
        const { flowForecasts } = this.searchResult;
        let updatedSortedFlow = this.mappingDates(flowForecasts);
        for (let item in updatedSortedFlow) {
          x = this.dateToUTC(updatedSortedFlow[item].date);
          y = updatedSortedFlow[item].value.flow;
          data.push([x, y]);
        }
        serie = {
          name: "Vazão",
          data: data,
          type: "line",
          yAxis: 1,
          tooltip: {
            valueSuffix: " m³/s",
            valueDecimals: 3
          },
          title: {
            enabled: true,
            text: "Vazão (m³/s)",
            style: {
              color: "#FFFFFF"
            }
          },
          color: "#95A1EC"
        }
        //flow
        this.series.push(serie);
        //flow
        this.description = `De ${moment(this.searchResult.dataType.date_start).format('MMM/YYYY')} até ${moment(this.searchResult.dataType.date_end).format("MMM/YYYY")}`,
        this.caption = {
            text: `Gráfico com dados mensais de ${moment(this.searchResult.dataType.date_start).format('MMM/YYYY')} até ${moment(this.searchResult.dataType.date_end).format("MMM/YYYY")}`,
            style: { color: "#FFFFFF" },
          };
      }
    },
    mappingDates(arrayList){
      const newList = arrayList.map((item) => {
        return { date: item.year+'-'+item.month, ...item }
      });
      return newList;
    },
    exportDataTable(settings) {
      const { fileType } = settings;
      const typeTable = this.getType;
      const isDailyMonthlyTable = typeTable === "diario" || typeTable === "mensal";
      const isHourlyTable = typeTable === "horario";
      if (fileType === "pdf") {
        if (isDailyMonthlyTable) {
          this.$refs[this.dailyMonthlyTableDataRef].generatePDF();
        }
        if (isHourlyTable) {
          this.$refs[this.hourlyTableDataRef].generatePDF(settings);
        }
      }
      if (fileType === "csv") {
        if (isDailyMonthlyTable) {
          this.$refs[this.dailyMonthlyTableDataRef].generateCSV();
        }
        if (isHourlyTable) {
          this.$refs[this.hourlyTableDataRef].generateCSV(settings);
        }
      }
      if (fileType === "xls") {
        if (isDailyMonthlyTable) {
          this.$refs[this.dailyMonthlyTableDataRef].generateXLS();
        }
        if (isHourlyTable) {
          this.$refs[this.hourlyTableDataRef].generateXLS(settings);
        }
      }
    },
    processResultForTable(searchResult) {
      const { type, resultList, date_start, date_end } = searchResult;
      const datesInterval = this.makeIntervalDates(type, date_start, date_end);
      let resultListCopy = [];
      if (type === "mensal") resultListCopy = resultList;
      if (type === "diario") resultListCopy = resultList[0].value;
      let checkedHoles = this.checkHoles(type, resultListCopy, datesInterval);
      return { ...searchResult, resultList: checkedHoles };
    },
    makeIntervalDates(type, min, max) {
      let interval = [];
      let stringFormat =
        type === "mensal"
          ? "YYYY-MM"
          : type === "diario"
          ? "YYYY-MM-DD"
          : "YYYY-MM-DDTHH:mm:ss+0000";
      min = moment(min).tz("America/Sao_Paulo").utc().format(stringFormat);
      max = moment(max).tz("America/Sao_Paulo").utc().format(stringFormat);
      if (type === "diario") {
        let diff = moment(max, stringFormat).diff(moment(min, stringFormat), "days");
        for (let i = 0; i <= diff; i++) {
          let number = parseInt(i);
          let val = moment(min, stringFormat)
            .locale("pt-br")
            .add(number, "days")
            .format(stringFormat);
          interval.push(val);
        }
      } else if (type === "mensal") {
        let diff = moment(max, stringFormat)
          .locale("pt-br")
          .diff(moment(min, stringFormat), "months");
        for (let i = 0; i <= diff; i++) {
          let number = parseInt(i);
          let val = moment(min, stringFormat)
            .locale("pt-br")
            .add(number, "months")
            .format(stringFormat);
          interval.push(val);
        }
      } else if (type === "horario") {
        let diff = moment(max, stringFormat).diff(moment(min, stringFormat), "hours");
        for (let i = 0; i <= diff; i++) {
          let number = parseInt(i);
          let val = moment(min, stringFormat)
            .locale("pt-br")
            .add(number, "hours")
            .format(stringFormat);
          interval.push(val);
        }
      }
      return [...interval];
    },
    checkHoles(type, copy, dates) {
      let aux = [];
      const pattern = copy[0];
      for (let index in dates) {
        if (type === "diario") {
          let item = "";
          item = copy.find((a) => a.data === dates[index]);
          if (item) {
            aux.push(item);
          } else {
            let holder = {
              ...pattern,
            };
            holder.valor = null;
            holder.data = dates[index];
            aux.push(holder);
          }
        } else if (type === "mensal") {
          let item = "";
          item = copy.find((a) =>
            moment(dates[index], "YYYY-MM").isSame(a.data, "months")
          );
          if (item) {
            aux.push(item);
          } else {
            let holder = {
              ...pattern,
            };
            holder.valor = null;
            holder.data = dates[index];
            aux.push(holder);
          }
        } else if (type === "horario" || type === "observado") {
          const item = copy.find((a) =>
            moment(a.datahora).utc().isSame(moment(dates[index]).utc(), "hours")
          );
          if (item) {
            item.data = item.datahora;
            aux.push(item);
          } else {
            let holder = {
              ...pattern,
            };
            holder.valor = null;
            holder.data = dates[index];
            aux.push(holder);
          }
        }
      }
      return [...aux];
    },
    applyPeriod(periodSelected) {
      this.otherPeriodSelected = periodSelected;
      this.$emit("applyPeriod", periodSelected);
    },
    loadAnimationComplete() {
      this.showAnimation = this.loadingOtherPeriod || this.loadingData;
    },
    changeTabItem(tabIndex) {
      this.tab = tabIndex;
    },

    chartRenderComplete(chart) {
      this.chartRendered = chart;
    },
    exportChart(typeFile) {
      this.chartRendered.exportChart({ type: typeFile });
    },
    exportPDF() {
      if (this.isTableTab) {
        //this.$refs.settingsExportDialog.openSettingsDialog("pdf");
        const settings = {
          fileType: "pdf",
          option: "none",
          replaceData: "",
        };
        this.exportDataTable(settings);
      }
    },

    exportCSV() {
      if (this.isTableTab) {
        //this.$refs.settingsExportDialog.openSettingsDialog("csv");
        const settings = {
          fileType: "csv",
          option: "none",
          replaceData: "",
        };
        this.exportDataTable(settings);
      } else {
        this.chartRendered.downloadCSV();
      }
    },
    exportXLS() {
      if (this.isTableTab) {
        //this.$refs.settingsExportDialog.openSettingsDialog("xls");
        const settings = {
          fileType: "xls",
          option: "none",
          replaceData: "",
        };
        this.exportDataTable(settings);
      } else {
        this.chartRendered.downloadXLS();
      }
    },
    fullscreenChart() {
      const fullscreenControl = new Highcharts.Fullscreen(this.chartRendered);
      fullscreenControl.open();
    },
    printChart() {
      this.chartRendered.print();
    },

    exportChartAuthorization(authorization) {
      this.exportChartAuthorized = authorization;
    },

    formatDate(date) {
      const { type } = this.searchResult;
      const stringFormat =
        type === "mensal"
          ? "MMMM/YYYY"
          : type === "diario"
          ? "DD/MM/YYYY"
          : "DD/MM/YYYY HH:mm";
      const dateFormated = moment(date)
        .tz("America/Sao_Paulo")
        .locale("pt-br")
        .format(stringFormat);
      return type === "mensal" ? this.capitalize(dateFormated) : dateFormated;
    },

    dateToUTC(x) {
      let utc;
      let type = this.searchResult.type;
      let stringFormat =
        type === "mensal"
          ? "YYYY-MM"
          : type === "diario"
          ? "YYYY-MM-DD"
          : "YYYY-MM-DDTHH:mm:ss+0000";
      if (type === "diario") {
        utc = moment(x, stringFormat).locale("en").format(stringFormat);
        x = moment.utc(utc).locale("en").valueOf();
      } else if (type === "mensal") {
        utc = moment(x, stringFormat).locale("en").format(stringFormat);
        x = moment.utc(utc).locale("en").valueOf();
      } else if (type === "horario") {
        const localDate = moment(x).tz("America/Sao_Paulo").format("YYYY-MM-DD HH:mm");
        x = moment.utc(localDate).locale("en").valueOf();
      }

      return x;
    },

    capitalize(text) {
      return text[0].toUpperCase() + text.slice(1);
    },
    loadCharts() {
      setTimeout(() => {
        if (this.$refs.rainEstimationHistoricalDataChart) {
          this.$refs.rainEstimationHistoricalDataChart.chartPreprocessing();
          this.authorize = rainEstimationHistoricalDataAuthorization;
        }
      }, 50);
    },
  },
};
</script>

<style scoped>
.tab-item-title {
  color: var(--v-secondary-lighten1) !important;
  border: 1px solid var(--v-secondary-lighten1);
  text-transform: none;
}
#tab-charts {
  border-radius: 4px 0px 0px 4px;
}
#tab-table {
  border-radius: 0px 4px 4px 0px;
}
</style>
